import React from 'react';
import _ from 'lodash';

import { Modal, Icon, IconButton } from '@ts/storybook';
import Tooltip from '@components/Outputs/Tooltip';

import { Loading } from '@components/Misc';

import fileDownload from 'js-file-download';
import { parse } from 'json2csv';
import act from '@flux/actions/actView';

import { withTranslation } from 'react-i18next';

class CSVDownloader extends React.Component {
  state = {
    fetchingDownload: false,
  };

  componentDidUpdate() {
    const downloadOptions = _.get(this.props, 'downloadOptions');

    let json2csvConfig;
    if (this.state.fetchingDownload) {
      let data = this.props.data.getIn([this.props.csvDatapath, 'data']);
      if (data) {
        data = data.toJS();

        let defaultConfig = {
          fields: null,
        };
        if (typeof downloadOptions === 'function') {
          json2csvConfig = Object.assign(defaultConfig, {
            fields: this.translateLabels(downloadOptions(data).fields),
          });
        } else {
          json2csvConfig = Object.assign(defaultConfig, {
            fields: this.translateLabels(downloadOptions.fields),
          });
        }
        let fileName =
          _.get('this.props.downloadOptions.fileName') ||
          `${this.props.title || 'File'}_Export-${new Date().toISOString().substring(0, 19)}.csv`;
        if (this.props.fieldObjectRequest) {
          data = data[this.props.fieldObjectRequest];
        } else if (!Array.isArray(data)) data = data.rows ? data.rows : data;

        let csv = parse(data, json2csvConfig);
        fileDownload(csv, fileName);
        this.setState({ fetchingDownload: false }, () => {
          act.deleteResource(this.props.csvDatapath);
        });
      }
    }
  }

  render() {
    return (
      <div style={{ display: 'inline-block', width: '48px' }}>
        {this._renderModal()}
        <Tooltip placement="top" title={`${this.props.t('Download as CSV')}`}>
          <IconButton onClick={this._onDownload} disabled={!this.props.downloadOptions}>
            <Icon icon={'download'} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }

  translateLabels(fields) {
    return fields.map(field => {
      return {
        label: this.props.t(field.label).toString(),
        value: field.value,
      };
    });
  }

  _renderModal() {
    return (
      <Modal withHeader title="Preparing file..." labelCancel="Ok" open={this.state.fetchingDownload}>
        {this._renderModalContent()}
      </Modal>
    );
  }

  _renderModalContent() {
    return (
      <>
        <h2>{`${this.props.t('Preparing file for download...')}`}</h2>
        <Loading />
      </>
    );
  }

  _closeModal = () => {
    this.setState({ fetchingDownload: false });
  };
  _onDownload = () => {
    // fetch and show modal
    this.props.onDownload();
    this.setState({ fetchingDownload: true });
  };
}

export default withTranslation()(CSVDownloader);
